/**
 * Assessment Type Labels - Terminologia Counseling-Friendly
 * Metafora della crescita: piantina → albero
 */

export const ASSESSMENT_TYPES = {
    T0: 'Colloquio Iniziale',
    T1: 'Verifica Intermedia',
    T2: 'Bilancio Finale'
};

export const ASSESSMENT_ICONS = {
    T0: '🌱',
    T1: '🌿',
    T2: '🌳'
};

export const ASSESSMENT_DESCRIPTIONS = {
    T0: 'Prima raccolta dati all\'inizio del percorso',
    T1: 'Verifica progressi a metà percorso',
    T2: 'Bilancio conclusivo del percorso terapeutico'
};

// Helper per ottenere label da type
export const getAssessmentLabel = (type) => {
    return ASSESSMENT_TYPES[type] || type;
};

export const getAssessmentIcon = (type) => {
    return ASSESSMENT_ICONS[type] || '📊';
};
